import { render, staticRenderFns } from "./AddressDialog.vue?vue&type=template&id=27bd9565&"
import script from "./AddressDialog.vue?vue&type=script&lang=js&"
export * from "./AddressDialog.vue?vue&type=script&lang=js&"
import style0 from "./AddressDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports